import { MODULE_NAME } from './../constants';
export function selectSsoState(state) {
    return state[MODULE_NAME];
}
export function selectSsoServices(state) {
    return selectSsoState(state).services;
}
export function selectSsoRequest(state) {
    return selectSsoState(state).ssoRequest;
}
